import { render } from "./SpreadsheetWorkflowHooks.vue?vue&type=template&id=08987fa2&scoped=true"
import script from "./SpreadsheetWorkflowHooks.vue?vue&type=script&lang=js"
export * from "./SpreadsheetWorkflowHooks.vue?vue&type=script&lang=js"

import "./SpreadsheetWorkflowHooks.vue?vue&type=style&index=0&id=08987fa2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08987fa2"]])

export default __exports__